export default "__VITE_ASSET__px7mL9$8__"